var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4986 19.0312H22.4154C22.8884 19.0312 23.318 19.3072 23.5145 19.7375L24.8944 22.7584C25.2599 23.5586 24.6751 24.4688 23.7953 24.4688H14.4986M14.4986 19.0312H6.58182C6.10878 19.0312 5.67926 19.3072 5.48272 19.7375L4.10283 22.7584C3.73729 23.5586 4.32215 24.4688 5.20193 24.4688H14.4986M14.4986 19.0312V24.4688V19.0312Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4986 19.0312H22.4154C22.8884 19.0312 23.318 19.3072 23.5145 19.7375L24.8944 22.7584C25.2599 23.5586 24.6751 24.4688 23.7953 24.4688H14.4986M14.4986 19.0312H6.58182C6.10878 19.0312 5.67926 19.3072 5.48272 19.7375L4.10283 22.7584C3.73729 23.5586 4.32215 24.4688 5.20193 24.4688H14.4986M14.4986 19.0312V24.4688",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6797 4.53125C11.0888 6.26321 12.6447 7.55208 14.5017 7.55208C16.3586 7.55208 17.9146 6.26321 18.3236 4.53125",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.7812V13.5938M22.6562 4.53125H24.4688M4.53125 4.53125H6.34375M9.0625 9.66667L7.85417 10.875M19.9375 9.66667L21.1458 10.875",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.e9ddc47c53e79f1a90af785e24434cac.svg";
export { ForwardRef as ReactComponent };